import {  useEffect, useRef } from "react";
import React from "react";
import { useHistory } from 'react-router-dom';
import useCurrentLocale from "../../hooks/useLanguage";
import { getSlugFromName } from "../../utils/helpers";


export default function ItemCategories({
  categories,
  activeCategory,
}: any) {
  const navRef = useRef<HTMLDivElement | null>(null);
  const history = useHistory();
  const lang = useCurrentLocale();
  useEffect(() => {
    if (activeCategory) {
      const categoryElement = document.getElementById(
        `category-${activeCategory}`
      );
      if (categoryElement && navRef.current) {
        categoryElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });

      }
    }
    // setTimeout(()=>{
    //   window.history.replaceState(null, "", `#${activeCategory}`);
    // },500)
  }, [activeCategory]);

  
  return (
    <nav ref={navRef} className="category-container mobile-scroll">
      {categories?.map((category: any) => {
        const group_name = category.group_name
          .replace(/\s+/g, "");

        return (
          category.dataLength > 0 && (
            <button
              key={category.group_id}
              id={`category-${group_name}`}
              onClick={() => {
                const element = document.getElementById(group_name);
                if (element) {
                  const elementTop = element.getBoundingClientRect().top;
                  const isMobile = window.innerWidth < 768; // you can adjust breakpoint
                  history.push(`/${lang}/menu#${getSlugFromName(category.group_name)}`);
                  const offset = isMobile ? 180 : 150;
                  const scrollPosition = window.scrollY + elementTop - offset;

                  window.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth",
                  });
                }
              }}
              className={`${
                activeCategory == group_name && "category-active"
                }`}
            >
              {category.group_name}
            </button>
          )
        );
      })}
    </nav>
  );
}
